export { default } from './ProviderEdit'


// WEBPACK FOOTER //
// ./src/scenes/Administration/Provider/ProviderEdit/index.js